<h2 mat-dialog-title>{{'dashboard.preferences.telegramTileModal' | translate}}
  <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<div mat-dialog-content>
  <div class="dialogContent">
    <div class="imageWrapper">
      <img aria-label="QR" src="{{link | qrCode}}">
      <div class="loader"></div>
    </div>
    <div>
      <a mat-stroked-button href="{{link}}">
        <mat-icon>open_in_new</mat-icon> {{'dashboard.preferences.telegramOpenLinkButtonInModal' | translate}}
      </a>
      &nbsp;
      <a mat-stroked-button [cdkCopyToClipboard]="link" (cdkCopyToClipboardCopied)="onClipboardCopy($event)">
        <mat-icon>content_copy</mat-icon> {{'dashboard.preferences.telegramCopyLinkButtonInModal' | translate}}
      </a>
    </div>
  </div>
</div>
